import axios from 'axios';
import { toast } from 'react-toastify';
import store from 'src/redux/store';
import * as actionTypes from '../redux/action/actionTypes';

export const sessionExpire = () => {
  toast.error('Session expired. Redirecting you to the login page.');
  setTimeout(() => {
    localStorage.clear();
    window.location.assign('/login');
  }, 1000);
};

// new: mark IP as blocked in redux
export const forbiddenSession = () => {
  try {
    store.dispatch({ type: actionTypes.SET_IP_BLOCKED, isIPBlocked: true });
  } catch (err) {
    console.error('forbiddenSession dispatch failed', err);
  }
};

export const Fetch = async (...props) => {
  return await fetch(...props).then((res) => {
    if (res.status === 401) {
      sessionExpire();
      return false;
    } else if (res?.status == 403) {
      // For 403, check if the body contains a 401 code (UNAUTHORIZED)
      return res
        .json()
        .then((data) => {
          if (data?.code == '401' || data?.status === 'UNAUTHORIZED') {
            sessionExpire();
            return false;
          } else if (data?.message == 'FORBIDDEN_BY_IP') {
            forbiddenSession();
            return false;
          }
          return res;
        })
        .catch(() => res);
    } else {
      return res;
    }
  });
};

export const GetApi = async (URL, header) => {
  try {
    const response = await axios.get(URL, header);
    if (
      response?.status === 200 ||
      response?.status === 201 ||
      response?.status === 'SUCCESS'
    ) {
      return response;
    } else if (
      response?.code == '403' &&
      response?.message == 'FORBIDDEN_BY_IP'
    ) {
      forbiddenSession();
    } else if (response?.code === 401) {
      sessionExpire();
    }
  } catch (error) {
    if (
      error?.response?.data?.code == '403' &&
      error?.response?.data?.message == 'FORBIDDEN_BY_IP'
    ) {
      forbiddenSession();
    } else if (
      error?.response?.data?.code == '401' ||
      error?.response?.data?.status === 'UNAUTHORIZED'
    ) {
      sessionExpire();
    } else
      toast.error('Something went wrong.', {
        limit: 1,
        autoClose: 2000
      });

    return error;
  }
};

export const PostApi = async (URL, data, header = {}) => {
  try {
    const isFormData = data instanceof FormData;

    const incomingHeaders = { ...(header.headers || {}) };

    Object.keys(incomingHeaders).forEach((key) => {
      if (key.toLowerCase() === 'content-type') {
        delete incomingHeaders[key];
      }
    });

    const config = {
      headers: {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),

        ...incomingHeaders
      }
    };
    const response = await axios.post(URL, data, config);

    if (
      response?.status === 200 ||
      response?.status === 201 ||
      response?.status === 'SUCCESS'
    ) {
      return response;
    } else if (
      response?.code == '403' &&
      response?.message == 'FORBIDDEN_BY_IP'
    ) {
      forbiddenSession();
    } else if (response?.code === 401) {
      sessionExpire();
    } else {
      return response;
    }
  } catch (error) {
    if (
      error?.response?.data?.code == '403' &&
      error?.response?.data?.message == 'FORBIDDEN_BY_IP'
    ) {
      forbiddenSession();
    } else if (
      error?.response?.data?.code == '401' ||
      error?.response?.data?.status === 'UNAUTHORIZED'
    ) {
      sessionExpire();
    } else
      error?.response?.data?.message
        ? toast.error(error?.response?.data?.message)
        : toast.error('Something went wrong.', {
            limit: 1,
            autoClose: 2000
          });

    return error;
  }
};

export const DeleteApi = async (URL, data = {}) => {
  try {
    const response = await axios.delete(URL, data);

    if (
      response?.status === 200 ||
      response?.status === 201 ||
      response?.status === 'SUCCESS'
    ) {
      return response;
    } else if (
      response?.code == '403' &&
      response?.message == 'FORBIDDEN_BY_IP'
    ) {
      forbiddenSession();
    } else if (response?.code === 401) {
      sessionExpire();
    }
  } catch (error) {
    if (
      error?.response?.data?.code == '403' &&
      error?.response?.data?.message == 'FORBIDDEN_BY_IP'
    ) {
      forbiddenSession();
    } else if (
      error?.response?.data?.code == '401' ||
      error?.response?.data?.status === 'UNAUTHORIZED'
    ) {
      sessionExpire();
    } else
      toast.error('Something went wrong.', {
        limit: 1,
        autoClose: 2000
      });
    return error;
  }
};

export const PutApi = async (URL, data, header = {}) => {
  try {
    const response = await axios.put(URL, data, header);

    if (
      response?.status === 200 ||
      response?.status === 201 ||
      response?.status === 'SUCCESS'
    ) {
      return response;
    } else if (
      response?.code == '403' &&
      response?.message == 'FORBIDDEN_BY_IP'
    ) {
      forbiddenSession();
    } else if (response?.code === 401) {
      sessionExpire();
    }
  } catch (error) {
    if (
      error?.response?.data?.code == '403' &&
      error?.response?.data?.message == 'FORBIDDEN_BY_IP'
    ) {
      forbiddenSession();
    } else if (
      error?.response?.data?.code == '401' ||
      error?.response?.data?.status === 'UNAUTHORIZED'
    ) {
      sessionExpire();
    } else
      error?.response?.data?.message
        ? toast.error(error?.response?.data?.message)
        : toast.error('Something went wrong.', {
            limit: 1,
            autoClose: 2000
          });

    return error;
  }
};

export const PostArrayBuffer = async (url, data, header) => {
  return await axios
    .post(url, data, {
      headers: header,
      responseType: 'arrayBuffer'
    })
    .then((res) => res)
    .catch((err) => {
      if (
        err?.response?.data?.code == '403' &&
        err?.response?.data?.message == 'FORBIDDEN_BY_IP'
      ) {
        forbiddenSession();
      } else if (
        err?.response?.data?.code == '401' ||
        err?.response?.data?.status === 'UNAUTHORIZED'
      ) {
        sessionExpire();
      }
      return err.response;
    });
};
